
import React from 'react'

import { Box, Card, Typography } from '@mui/material'

const TotalProjectCard = ({ title, score, icon, bgColor, fontColor, borderLeft, dashboardData, onClick }) => {
    return (
        <Box onClick={() => onClick?.("Total Project")} sx={{ cursor: "pointer" }}>
            <Card
                sx={{
                    width: "100%",
                    height: 158,
                    color: "white",
                    borderRadius: 3,
                    boxShadow: "0px 4px 20px rgba(0,0,0,0.2)",
                    p: 1.5,
                    transition: "0.3s",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    ml: 1.8,
                    background: "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(133, 24, 82, 0.1) 100%)",
                    borderLeft: "10px solid #851852",
                    "&:hover": {
                        transform: "scale(1.05)",
                        boxShadow: "0px 6px 25px rgba(0,0,0,0.3)",
                    },
                }}
            >

                <Typography
                    variant="h5"
                    sx={{
                        opacity: 0.8,
                        fontFamily: "Montserrat",
                        fontWeight: "bold",
                        fontSize: "16px",
                        lineHeight: "100%",
                        letterSpacing: 0,
                        color: '#0B0B0A'
                    }}
                >
                    Total Projects
                </Typography>


                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        // px: 1,
                    }}
                >
                    <Typography
                        variant="h6"
                        fontWeight="bold"
                        sx={{ fontSize: "35px", color: '#851852' }}
                    >

                        {dashboardData?.total_project}
                    </Typography>
                </Box>
            </Card>
        </Box>
    )
}

export default TotalProjectCard
